import React, { useState, useEffect } from "react";

import axios from "axios";
import routes from "../../app/routes";

import { useClaimContext } from "../../contexts/ClaimContext";
import { DisableTextField, SelectField } from "../../ui/FormElement";

const Members = React.forwardRef((prop, ref) => {
  const [collection, setCollection] = useState([]);
  const [memberInfo, setMemberInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const { dispatch, state, actions } = useClaimContext();

  useEffect(() => {
    actions.loadMembers(dispatch);
  }, []);

  const onMemberChange = (opt) => {
    if (opt == null) {
      setMemberInfo(null);
    } else {
      setLoading(true);
      axios
        .get(routes.api.students.show(opt.value), {
          params: {
            last_completed_program: true,
          },
        })
        .then((resp) => {
          setMemberInfo(resp.data.data);
          setLoading(false);
        });
    }
  };

  return (
    <>
      <SelectField
        ref={ref}
        name="member"
        options={state.members}
        placeholder={
          state.members == null ? "Please, wait..." : "Choose Member..."
        }
        label={
          <>
            <span>Member</span>
            <abbr title="required">*</abbr>
          </>
        }
        onCustomonChange={onMemberChange}
      />
      {loading && <div>Please, wait ...</div>}
      {memberInfo != null && (
        <>
          <div>
            <DisableTextField
              label="Program*"
              value={memberInfo.attributes.last_program.title}
            />
          </div>
          <div>
            <DisableTextField
              label="Completed*"
              value={
                memberInfo.attributes.last_program.last_session_completed_date
              }
            />
          </div>
        </>
      )}
    </>
  );
});

export default Members;
